import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/maintenanceRecord',
  component: LAYOUT,
  name: 'MaintenanceRecord',
  redirect: '/maintenancerecord/list',
  meta: {
    title: '保养记录',
  },
  children: [
    {
      path: 'list',
      name: 'MaintenanceRecordList',
      meta: {
        title: '保养记录',
      },
      component: () => import('@/views/maintenanceRecord/index.vue'),
    }, {
      path: 'detail',
      name: 'MaintenanceRecordDetail',
      meta: {
        title: '保养详情',
      },
      component: () => import('@/views/maintenanceRecord/detail/index.vue'),
    }, {
      path: 'moreSearch',
      name: 'MaintenanceRecordMoresearch',
      meta: {
        title: '保养记录',
      },
      component: () => import('@/views/maintenanceRecord/moreSearch/index.vue'),
    },
  ],
};
